<template>
    <div class="info-edit">
        <!-- 头部 -->
        <head-bar title="预付货款协议" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <div class="main_content">
            <div class="agreement_text">
                <p>甲方:{{ walletInfo.companyName }}</p>
                <p>乙方:{{ $config.BANK_INFO.company }}</p>
                <p class="retract_text">
                    鉴于甲方拟持续向乙方采购电子元器件，为提升甲方的采购效率，甲方同意向乙方预付货款，双方就此签订本协议，以资双方遵守：
                </p>
                <p>一、预付货款金额、用途与付款时间</p>
                <p class="retract_text">
                    甲方向乙方银行账户支付款项，作为甲方在乙方网上平台油柑网上采购电子元器件的预付货款，甲方在乙方平台上的所有采购订单均含13%增
                    值税。
                </p>
                <p>二、预付款结算与退还</p>
                <p class="retract_text">
                    甲方采购的每笔交易订单将由乙方平台系统提供销售合同，乙方将根据每笔订单合同的金额相应地在甲方的预付货款中扣除，若预付货款已扣
                    除完毕，甲方可继续支付预付货款，每次具体金额以甲方实际付款为准。如双方终止合作后甲方仍留有剩余货款在乙方，由甲方提出退回货款申请
                    ，乙方将在3个工作日内将剩余货款退回甲方，退回账户必须是以甲方公司开户的公账账户。
                </p>
                <p>三、预付货款收款账户</p>
                <p class="retract_text">乙方:{{ $config.BANK_INFO.company }}</p>
                <p class="retract_text">
                    通讯地址:深圳市福田区华强北街道华强北路1019号华强广场A座-16N
                </p>
                <p class="retract_text">
                    开户银行:{{ $config.BANK_INFO.address }}
                </p>
                <p class="retract_text">
                    银行账户:{{ $config.BANK_INFO.account }}
                </p>
                <p class="retract_text">电话:0755-82538015</p>
                <p>四、支付密码的保存</p>
                <p class="retract_text">
                    支付密码由甲方妥善保存，乙方在任何情况下不会向甲方索要支付密码，因支付密码泄露造成的损失，由甲方承担。
                </p>
            </div>
            <div class="button_group">
                <div
                    class="button_item"
                    @click="goToRegister"
                    v-if="
                        walletInfo.walletState ==
                            statusMap.wallet_status_not_opened
                    "
                >
                    <span>我已阅读并同意该协议</span>
                </div>
                <div
                    class="button_item"
                    @click="goToBack"
                    v-if="
                        walletInfo.walletState !=
                            statusMap.wallet_status_not_opened
                    "
                >
                    <span>确认</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { Field, Button, Switch, Cell, Dialog } from "vant";
import HeadBar from "@/components/HeadBar";
import {
    wallet_status_not_opened,
    wallet_status_feoze,
    wallet_status_unsubscribe,
    wallet_status_lock,
    wallet_status_normal,
    wallet_status_insufficient,
} from "../../../definition/status/wallet";

Vue.use(Field);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Dialog);

export default {
    components: { HeadBar },
    data() {
        return {
            walletInfo: {
                walletState: wallet_status_not_opened,
                companyName: "采购公司",
            },
            statusMap: {
                wallet_status_not_opened,
            },
            isLoad: false,
        };
    },
    computed: {},
    created() {
        this.getWalletInfo();
    },
    methods: {
        /**
         * @description 获取用户钱包信息
         */
        getWalletInfo() {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let _this = this;
            const url = this.$api.userApi.queryWalletInfo;
            this.isLoad = false;
            this.$axios
                .post(url, {})
                .then((res) => {
                    this.isLoad = true;
                    let { data: walletInfo = {} } = res;
                    this.walletInfo = walletInfo;
                })
                .catch(() => {
                    _this.goToBack();
                })
                .finally(() => {
                    this.$toast.clear();
                });
        },
        goToBack() {
            this.$router.replace({
                path: "/user/wallet",
            });
        },
        goToRegister() {
            if (!this.isLoad) return;
            this.$router.replace({
                path: "/user/wallet/apply",
            });
        },
    },
};
</script>

<style lang="less" scoped>
.info-edit {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            *display: inline;
            display: inline-block;
            zoom: 1;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .main_content {
        padding-top: 90px;
        padding-bottom: 60px;
    }
}
.agreement_text {
    padding: 20px 30px;
    p {
        font-size: 28px;
        color: #333;
        &.retract_text {
            text-indent: 2em;
        }
    }
}
.button_group {
    width: 750px;
    .button_item {
        margin: 0 auto;
        width: 690px;
        height: 70px;
        background-color: #4bc227;
        border-radius: 36px;
        font-size: 28px;
        line-height: 70px;
        color: #fff;
        text-align: center;
        &.margin_top_40 {
            margin-top: 40px;
        }

        &.margin_top_20 {
            margin-top: 20px;
        }

        &.skip_button {
            background-color: #96eb7c;
        }
    }
}
</style>
